module.exports = __webpack_public_path__ + "static/media/57-iveco.175b203b.jpg";